import { useQuery } from "@apollo/client";
import ApexCharts from "apexcharts";
import React, { useEffect, useState } from "react";
import { toastr } from "react-redux-toastr";
import store from "../../../../redux/store";
import { notificationClient } from "../../../../redux/setupApolloClient";
import { GET_FAILED_LOGINS_IN_DATE_RANGE, GET_LOGINS_COUNT } from "../../../../app/Modules/Administration/_Commons/Constants/Queries/LoginAudit";
import { GET_AUDITS_COUNT } from "../../../../app/Modules/_Commons/Constants/Queries/Audits";
import {GET_LOGS_COUNT } from "../../../../app/Modules/Administration/_Commons/Constants/Queries/Logs";

export function AdvanceTablesWidget6({ className, Start_Date, End_Date }) {
  const [failedLogins, setFailedLogins] = useState([]);
  const [client, setClient] = useState(null);

  const [logins, setLogins] = useState(0);
  const [audits, setAudits] = useState(0);
  const [logs, setLog] = useState(0);
  

  const [FailedLoginsLimit, /* setFailedLoginsLimit */] = useState(1000);

  useEffect(() => setClient(notificationClient(store)), []);

  const handleGetLoginsCount = useQuery(GET_LOGINS_COUNT, { client });
  const handleGetAuditsCount = useQuery(GET_AUDITS_COUNT, { client });
  const handleGetLogsCount = useQuery(GET_LOGS_COUNT, { client });

  useEffect(() => {
    const { loading, error, data } = handleGetLoginsCount;
    
    if (error) toastr.error("Failed to load logins graph data", error.message);

    if (!loading && data && data?.loginCount) {
      const numberOfLogin = data?.loginCount?.Count;
      setLogins(numberOfLogin);
    }
  }, [handleGetLoginsCount]);

  useEffect(() => {
    const { loading, error, data } = handleGetAuditsCount;

    if (error) toastr.error("Failed to load audits graph data", error.message);

    if (!loading && data?.auditsCount) {
      const numberOfAudits = data?.auditsCount?.Count;
      setAudits(numberOfAudits);
    }
  }, [handleGetAuditsCount]);

  useEffect(() => {
    const { loading, error, data } = handleGetLogsCount;    
    
    if (error) toastr.error("Failed to load logs count graph data", error.message);
    
    if (!loading && data && data?.logsCount) {
      const numberOfLogs = data?.logsCount?.Count;
      setLog(numberOfLogs);
    }
  }, [handleGetLogsCount]);

  const handleGetFailedLogins = useQuery(GET_FAILED_LOGINS_IN_DATE_RANGE, {
    client,
    variables: {
      StartDate: Start_Date,
      EndDate: End_Date,
      Offset: 0,
      Limit: Number(FailedLoginsLimit),
    },
    skip: !(client && Start_Date && End_Date && End_Date >= Start_Date),
  });

  useEffect(() => {
    const { loading, error, data } = handleGetFailedLogins;

    if (error) toastr.error("Failed to load failed logins graph data", error.message);
    if (error) console.error(JSON.stringify(error, null, 2));
    if (!loading && data && data.failedLoginsInDateRange && data.failedLoginsInDateRange.dataList) {
      const failedLogins = data.failedLoginsInDateRange.dataList;
      const monthsData = {
        0: 0,
        1: 0,
        2: 0,
        3: 0,
        4: 0,
        5: 0,
        6: 0,
        7: 0,
        8: 0,
        9: 0,
        10: 0,
        11: 0,
      };

      let sortedLogins = monthsData;

      failedLogins.forEach((log) => {
        const createdDateMonth = new Date(log.Created_Date).getMonth();
        sortedLogins[createdDateMonth] =
          createdDateMonth && sortedLogins[createdDateMonth] ? parseInt(sortedLogins[createdDateMonth]) + 1 : 1;
      });
      sortedLogins = sortedLogins && Object.keys(sortedLogins).map((log) => sortedLogins[log]);

      setFailedLogins(sortedLogins);
    }
  }, [handleGetFailedLogins, Start_Date, End_Date]);

  useEffect(() => {
    const element = document.getElementById("kt_advanced_table_widget_6_chart");

    if (!element) {
      return;
    }

    let options = getChartOptions();

    options.series = [logins, audits, (logs/1000)];

    const chart = new ApexCharts(element, options);

    chart.render();

    return function cleanUp() {
      chart.destroy();
    };
  }, [logins, audits, logs, failedLogins]);

  return (
    <div className={`card card-custom ${className}`}>
      <div className="card-header border-0 pt-5 ">
        <h3 className="card-title align-items-start flex-column">
          <span className="card-label font-weight-bolder text-dark">Overall Overview</span>
        </h3>
      </div>
      <div className="card-body pt-3 pb-0 mx-5">
        <div className="col-12 p-3 text-center">
          <div id="kt_advanced_table_widget_6_chart" className="w-100">            
          </div>
        </div>
      </div>
    </div>
  );
}

function getChartOptions() {
  const colors = ["#FFA800", "#F64E60", "#009933", "#333300", "#00ff00"];

  const options = {
    colors: colors,
    chart: {
      width: 480,
      type: "donut",
    },
    labels: ["Logins", "Audits", "Logs '000s'"],
    responsive: [
      {
        breakpoint: 380,
        options: {
          chart: {
            width: 200,
          },
          legend: {
            position: "center",
          },
        },
      },
    ],
  };

  return options;
}
